var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CompanyPay"},[_vm._v(" 银行卡汇款 手动开通 请联系客服QQ或邮箱 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }